<template>
  <div>
    <div class="top">
      <TopContent />
    </div>
    <div class="product_bg"></div>
    <div class="product_con">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><span @click="() => { this.$router.go(-1) }" class="goback">返回</span></el-breadcrumb-item>
        <el-breadcrumb-item>大数据推送系统</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="con_tit fontsize2">大数据推送系统</div>
      <p class="fontsize1">
        <span class="con_text">特点：</span><br>
        大数据推送系统针对医疗数据特殊性，充分利用 ADSL 宽带技术的非对称性特点，使医疗
        数据打破接入站点运营商的网络限制，实现数据互联互通。<br>
        1、安全可靠、高效率、系统运行稳定、无需人工干涉。<br>
        2、通过普通宽带即可完成庞大数据从一个接入点推送到另一个互联网接入点。<br>
        3、支持“一对多”推送、离线式推送。<br>
        4、接入的站点没有运营商网络的限制，充分利用ADSL 非对称的特点，避免互联网接入运营商间的通道瓶颈。<br><br>
        <span class="con_text">技术指标：</span>
        <br>
        1、支持 DICOM3.0 相关存储标准；<br>
        2、支持 HL7 相关标准；实现医学影像的高效高安全性互联网传输；<br>
        3、不同运营商之间的高效率和可靠传输；<br>
        4、解决 ADSL 站点间上行数据与下行数据传输速率不对称的问题；<br>
        5、实现一对多推送的高效率传输；实现动态 IP 地址间数据传输。<br><br>
        <span class="con_text">关键技术：</span>
        <br>
        多中继互联网大数据推送方法和系统<br>
        专利号：ZL 2016 1 0111050.6<br>
      </p>
      <div class="con_img"><img src="../../assets/img/Product1s.png" /></div>
    </div>
    <div class="bottom">
      <BottomContent />
    </div>
  </div>
</template>
<script>
import TopContent from "@/components/Top/index.vue";
import BottomContent from "@/components/Bottom/index.vue";
export default {
  components: { TopContent, BottomContent },
  data () {
    return {

    }
  },
  computed: {
    isMobile () {
      return window.innerWidth <= 1439;
    },
  },
  mounted () {
    this.load();
  },
  methods: {
    load () {
      if (document && document.body) {
        document.body.style.margin = '0px';
        this.originalBodyMargin = document.body.style.margin;
      }
    },
  }
}
</script>
<style lang="scss" src="../../assets/css/PC.scss" scoped></style>
<style lang="scss" scoped>
.goback:hover {
  cursor: pointer;
  color: #409EFF;
}

.bottom {
  height: 70px;
}

.product_bg {
  background-image: url("../../assets/img/Product_bg.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 70vh;
}

.fontsize1 {
  font-size: 19px;
}

.fontsize2 {
  font-size: 24px;
}

.product_con {
  width: 70%;
  margin: 0px auto 50px auto;
  padding: 20px;

  .con_tit {
    font-weight: 600;
    text-align: center;
    margin: 20px 0px;
  }

  .con_text {
    font-weight: 600;
  }

  .con_img {
    display: flex;
    justify-content: center;

    img {
      max-width: 40%;
      height: 100%;
    }

  }
}

@media (max-width: 1439px) and (min-width: 10px) {
  .product_bg {
    height: 30vh;
  }

  .fontsize1 {
    font-size: 15px;
  }

  .product_con {
    margin: auto;
    width: 90%;

    .con_img {
      img {
        max-width: 90%;
      }
    }
  }
}
</style>